import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';
import EditTracking from '../editor/EditTracking';

export const initTrackingValues = {
  tracking: {
    background: ['background'],
    start_button: ['start button'],
    result_button: ['reward button'],
    close_button: ['close button']
  }
};

const BasicFullRouletteTracking: FC = () => {
  const tracking = useSelector((state: RootState) => state.trackings.tracking);
  const currentPage = useSelector(
    (state: RootState) => state.pages.basicFullRoulettePage
  );

  const style = `
    .root_tracking {
      width: 100%;
      height: 100%;

      position: relative;
      background: none;
      overflow: hidden;

      .close_btn {
        width: 100%;
        position: absolute;
        right: 0;
        top: 6%;
      }

      .center {
        width: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        display: flex;
        flex-direction: column;
        gap: 0.5rem;
      }

      .roulette_wrapper {
        width: 100%;
        max-width: 400px;
        margin: 0 auto;
        position: relative;
      }

      .roulette_area {
        width: 100%;
        height: 350px;
        position: relative;
      }

      .start_btn_wrapper {
        width: 100%;
        height: 40px;

        position: absolute;
        bottom: 50px;
      }

      .reward_btn_wrapper {
        width: 100%;
        max-width: 360px;
        height: 3rem;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 25%;
      }

      .tracking_center {
        display: flex;
        align-items: center;
        justify-content: end;
      }
    }
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <div className="root_tracking">
        <div className="close_btn tracking_center">
          <EditTracking value={tracking?.close_button} type="close_button" />
        </div>

        {currentPage === 0 && (
          <div className="center">
            <div className="roulette_wrapper">
              <div className="roulette_area">
                <div className="start_btn_wrapper tracking_center">
                  <EditTracking
                    value={tracking?.start_button}
                    type="start_button"
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        {currentPage === 1 && (
          <div className="reward_btn_wrapper tracking_center">
            <EditTracking
              value={tracking?.result_button}
              type="result_button"
            />
          </div>
        )}
      </div>
    </>
  );
};

export default BasicFullRouletteTracking;
